import type React from 'react';
import {
  FOLLOW_COMPANIES,
  PROFILE_WISH,
} from '../../../../config/constants/routes';
import {isReleasedRedesignRecruitment} from '../../../../config/unReleasePage';
import {
  useGetRecommendedRecruitmentList,
  useGetSimilarRecruitmentList,
} from '../../../../core/repositories/recruitmentRepository';
import {useAuth} from '../../../../core/usecases/auth/AuthContext';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {GridRecruitmentList} from '../Container/Presenter/GridRecruitmentList';
import {RecruitmentList} from './RecruitmentList';
import {convertRecruitments} from './convertRecruitments';

export const RecommendedRecruitmentList: React.FC<{
  recruitmentDetailId: number;
}> = ({recruitmentDetailId}) => {
  const {status} = useAuth();
  const {data: similarList, isLoading: isLoadingSimilarList} =
    useGetSimilarRecruitmentList({
      recruitmentDetailId,
    });

  const {data: recommendedList, isLoading: isLoadingRecommendedList} =
    useGetRecommendedRecruitmentList({
      config: {
        enabled: status === 'authenticated',
      },
    });

  if (isReleasedRedesignRecruitment()) {
    return (
      <>
        {!isLoadingSimilarList &&
          similarList &&
          similarList.ok &&
          similarList.value.length > 0 && (
            <div className="mb-16">
              <RecruitmentList
                title="この募集情報を見ている方におすすめの募集"
                recruitments={convertRecruitments(similarList.value)}
                isGrid
                hasTargetYear={false}
              />
            </div>
          )}
        {status === 'authenticated' &&
          !isLoadingRecommendedList &&
          recommendedList &&
          recommendedList.ok &&
          recommendedList.value.length > 0 && (
            <div className="mb-16">
              <RecruitmentList
                title="あなたの志望・フォロー指向からおすすめの募集"
                recruitments={convertRecruitments(recommendedList.value)}
                isGrid
              />
            </div>
          )}
        {((similarList?.ok && similarList.value.length > 0) ||
          (status === 'authenticated' &&
            recommendedList?.ok &&
            recommendedList.value.length > 0)) && (
          <div>
            <p className="text-base text-black-2 leading text-center">
              気になる募集がありませんでしたか？
              <br />
              プロフィールの
              <CommonLink
                href={PROFILE_WISH}
                className="text-base text-link pc:hover:opacity-80 leading"
              >
                志望業界、志望職種を更新する
              </CommonLink>
              /
              <CommonLink
                href={FOLLOW_COMPANIES}
                className="text-base text-link pc:hover:opacity-80 leading"
              >
                フォロー企業を更新する
              </CommonLink>
            </p>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {!isLoadingSimilarList &&
        similarList &&
        similarList.ok &&
        similarList.value.length > 0 && (
          <div className="mb-16">
            <GridRecruitmentList
              sectionTitle="この募集情報を見ている方におすすめの募集"
              recruitmentList={similarList.value}
            />
          </div>
        )}
      {status === 'authenticated' &&
        !isLoadingRecommendedList &&
        recommendedList &&
        recommendedList.ok &&
        recommendedList.value.length > 0 && (
          <div className="mb-16">
            <GridRecruitmentList
              sectionTitle="あなたの志望・フォロー指向からおすすめの募集"
              recruitmentList={recommendedList.value}
            />
          </div>
        )}
      {((similarList?.ok && similarList.value.length > 0) ||
        (status === 'authenticated' &&
          recommendedList?.ok &&
          recommendedList.value.length > 0)) && (
        <div className="py-16">
          <p className="text-base text-black-2 leading text-center">
            気になる募集がありませんでしたか？
            <br />
            プロフィールの{' '}
            <CommonLink
              href={PROFILE_WISH}
              className="text-base text-link pc:hover:opacity-80 leading"
            >
              志望業界、志望職種を更新する
            </CommonLink>{' '}
            /{' '}
            <CommonLink
              href={FOLLOW_COMPANIES}
              className="text-base text-link pc:hover:opacity-80 leading"
            >
              フォロー企業を更新する
            </CommonLink>
          </p>
        </div>
      )}
    </>
  );
};
